export enum FLIPPER_ACTIONS {
  FETCH_FLIPPER_ITEM_REQUESTED = 'FLIPPER_ACTIONS.FETCH_FLIPPER_ITEM_REQUESTED',
  FETCH_FLIPPER_ITEM_SUCCEEDED = 'FLIPPER_ACTIONS.FETCH_FLIPPER_ITEM_SUCCEEDED',
  FETCH_FLIPPER_ITEM_FAILED = 'FLIPPER_ACTIONS.FETCH_FLIPPER_ITEM_FAILED',
}

export const FLIPPER_KEYS = {
  USD_TRANSFER_IN: 'straitsx_usd_transfer_in_ui',
  USD_TRANSFER_OUT: 'straitsx_usd_transfer_out_ui',
  USD_ADD_BANK_ACCOUNT: 'straitsx_add_usd_bank_account_ui',

  XUSD_ERC20_DEPOSIT: 'xusd_erc20_deposit',
  XUSD_ERC20_WITHDRAWAL: 'xusd_erc20_withdrawal',
  USDC_ERC20_DEPOSIT: 'usdc_erc20_deposit',
  USDC_ERC20_WITHDRAWAL: 'usdc_erc20_withdrawal',
  USDT_ERC20_DEPOSIT: 'usdt_erc20_deposit',
  USDT_ERC20_WITHDRAWAL: 'usdt_erc20_withdrawal',
  USDC_MATIC_DEPOSIT: 'usdc_matic_deposit',
  USDC_MATIC_WITHDRAWAL: 'usdc_matic_withdrawal',
  USDT_BEP20_DEPOSIT: 'usdt_bep20_deposit',
  USDT_BEP20_WITHDRAWAL: 'usdt_bep20_withdrawal',
  USDT_BEP20_UI: 'usdt_bep20_dashboard_ui',

  USDC_SWAP: 'straitsx_swap_enable_usdc',

  APP_DASHBOARD_USDT: 'straitsx_usdt_app_dashboard',
  BIZ_DASHBOARD_USDT: 'straitsx_usdt_biz_dashboard',
  XUSD_DASHBOARD_ENABLE: 'straitsx_xusd_dashboard_enable',

  APP_DASHBOARD_SWAP: 'xsgd_swap_ui',
  BIZ_DASHBOARD_SWAP: 'straitsx_swap_biz_dashboard',
  // TODO(duy): remove these flippers after releasing refactoring flow
  SWAP_DISABLED_ACCURATE_FEE_CALCULATION: 'straitsx_swap_disabled_accurate_fee_calculation',
  USDT_USDC_SWAP_APP_DASHBOARD: 'straitsx_usdt_usdc_swap_app_dashboard',
  USDT_XUSD_SWAP_APP_DASHBOARD: 'straitsx_usdt_xusd_swap_app_dashboard',
  USDT_USDC_SWAP_BIZ_DASHBOARD: 'straitsx_usdt_usdc_swap_biz_dashboard',
  USDT_XUSD_SWAP_BIZ_DASHBOARD: 'straitsx_usdt_xusd_swap_biz_dashboard',

  XIDR_ZRC2_DEPOSIT: 'xidr_zrc2_deposit',
  XIDR_BANK_DELETION: 'xidr_bank_deletion',
  XIDR_BLOCKCHAIN_ADDRESS_DELETION: 'xidr_blockchain_address_deletion',

  SGD_MEPS_DEPOSIT: 'straitsx_sgd_meps_deposit',
  SGD_MEPS_WITHDRAW: 'straitsx_sgd_meps_withdraw',

  SGD_SWIFT_DEPOSIT: 'straitsx_sgd_swift_deposit',
  SGD_SWIFT_WITHDRAW: 'straitsx_sgd_swift_withdraw',

  SWIFT_MEPS_NETWORK: 'straitsx_dashboard_enabled_account_transaction_limit_by_network',
  DBS_CHINESE_RESTRICTION_DEPOSIT: 'straitsx_dashboard_dbs_chinese_restriction_deposit',
  DBS_CHINESE_RESTRICTION_WITHDRAWAL: 'straitsx_dashboard_dbs_chinese_restriction_withdrawal',

  // Swap
  SWAP_XUSD_USDT: 'straitsx_swap_xusd_usdt', // TODO(duy): remove this flipper after release unified swap
  SWAP_USDC_USDT: 'straitsx_swap_usdc_usdt', // TODO(duy): remove this flipper after release unified swap
  SWAP_XUSD_USDC: 'straitsx_swap_xusd_usdc',
  SWAP_USDT_USDC: 'straitsx_swap_usdt_usdc',
  SWAP_USDT_XUSD: 'straitsx_swap_usdt_xusd',
  SWAP_XSGD_USDC: 'straitsx_swap_xsgd_usdc',
  SWAP_XSGD_XUSD: 'straitsx_swap_xsgd_xusd',
  SWAP_XSGD_USDT: 'straitsx_swap_xsgd_usdt',
  SWAP_SGD_XSGD: 'straitsx_swap_sgd_xsgd',
  SWAP_SGD_XUSD: 'straitsx_swap_sgd_xusd',
  SWAP_SGD_USDC: 'straitsx_swap_sgd_usdc',
  SWAP_SGD_USDT: 'straitsx_swap_sgd_usdt',
  SWAP_SGD_USD: 'straitsx_swap_sgd_usd',
  SWAP_USD_XSGD: 'straitsx_swap_usd_xsgd',
  SWAP_USD_XUSD: 'straitsx_swap_usd_xusd',
  SWAP_USD_USDC: 'straitsx_swap_usd_usdc',
  SWAP_USD_USDT: 'straitsx_swap_usd_usdt',

  // Verification
  SG_BIZ_MANUAL_ENHANCEMENT: 'straitsx_sg_biz_manual_enhancement',
  JUMIO_FLOW_FOR_SG_USER: 'straitsx_jumio_flow_for_sg_user',

  // Mint
  SG_MINT_DASHBOARD: 'straitsx_mint_dashboard',
  SG_TRANSACTION_TIMEZONE_CONTROL: 'straitsx_sg_transaction_timezone_control',
  HTS_DIRECT_MINT_DISABLED: 'straitsx_hts_direct_mint_disabled',
  ZRC_DIRECT_MINT_DISABLED: 'straitsx_zrc_direct_mint_disabled',
  ARB_DIRECT_MINT_DISABLED: 'straitsx_arb_direct_mint_disabled',

  // OTC
  SG_OTC_FORM_APP_DASHBOARD: 'straitsx_otc_form_app_dashboard',
  SG_OTC_FORM_BIZ_DASHBOARD: 'straitsx_otc_form_biz_dashboard',
  SG_OTC_TRX_HISTORY_APP_DASHBOARD: 'straitsx_otc_trx_history_app_dashboard',
  SG_OTC_TRX_HISTORY_BIZ_DASHBOARD: 'straitsx_otc_trx_history_biz_dashboard',

  // TODO(coffeestrike): Remove after OTC modal is working without issues for some time
  SG_OTC_MODAL_REDESIGN: 'straitsx_dashboard_otc_modal_redesign_ui',

  // MAS
  KILLSWITCH: 'straitsx_enable_killswitch',
  COOLING_DOWN: 'straitsx_enable_cooling_down',

  // Zendesk
  ZENDESK_ANSWERBOT: 'straitsx_enable_zendesk_answerbot',

  // Freshdesk
  FRESHDESK_ANSWERBOT: 'straitsx_enable_freshdesk_answerbot',

  // TRON
  TRON_WALLETCONNECT_DROPDOWN_UI: 'straitsx_tron_option_walletconnect_add_address',
  TRON_WITHDRAWAL_ESTIMATED_NETWORK_FEE: 'straitsx_tron_withdrawal_estimated_network_fee',

  // TODO(benedictkhoo): remove after assets unification is done
  // Fiat & Stablecoin Unification
  ASSETS_UNIFICATION_PHASE_1_STAGE_1: 'straitsx_dashboard_assets_unification_phase_1_stage_1',
  ASSETS_UNIFICATION_PHASE_1_STAGE_2: 'straitsx_dashboard_assets_unification_phase_1_stage_2',
  ASSETS_UNIFICATION_PHASE_1_STAGE_3: 'straitsx_dashboard_assets_unification_phase_1_stage_3',
  ASSETS_UNIFICATION_PHASE_1_BLACKLIST: 'straitsx_assets_unification_phase_1_blacklist',
  ASSETS_UNIFICATION_PHASE_1_PERSONAL_SWAP:
    'straitsx_dashboard_assets_unification_phase_1_personal_swap',
  ASSETS_UNIFICATION_PHASE_1_BUSINESS_SWAP:
    'straitsx_dashboard_assets_unification_phase_1_business_swap',
  ASSETS_UNIFICATION_PHASE_2: 'straitsx_dashboard_assets_unification_phase_2',
  ASSETS_UNIFICATION_PHASE_2_BLACKLIST: 'straitsx_assets_unification_phase_2_blacklist',

  // Landing Store
  STRAITSX_DPT_CHANGEOVER: 'straitsx_dpt_changeover',
  XSGD_HTS_WITHDRAWAL_FEE_CHARGING: 'xsgd_hts_withdrawal_fee_charging',
  XSGD_DASHBOARD_ETHEREUM_UI: 'xsgd_dashboard_ethereum_ui',
  XSGD_DASHBOARD_HEDERA_UI: 'xsgd_dashboard_hedera_ui',
  XSGD_DASHBOARD_POLYGON_UI: 'xsgd_dashboard_polygon_ui',
  XSGD_DASHBOARD_AVALANCHE_UI: 'xsgd_dashboard_avalanche_ui',
  USDT_DASHBOARD_TRON_UI: 'usdt_dashboard_tron_ui',
  XUSD_DASHBOARD_BNBSMART_APP_UI: 'xusd_dashboard_bnbsmart_app_ui',
  XSGD_DASHBOARD_ARBITRUM_UI: 'xsgd_dashboard_arbitrum_ui',
  XSGD_DASHBOARD_RIPPLE_UI: 'xsgd_dashboard_ripple_ui',
  XSGD_DASHBOARD_ZILLIQA_UI: 'xsgd_dashboard_zilliqa_ui',
  SSO_TWO_FA_AUTHENTICATOR: 'sso_two_fa_authenticator',
  STRAITSX_DPT_RISK_MODAL: 'straitsx_dpt_risk_modal',
  STRAITSX_ENABLE_FAZZ_VA_FOR_DASHBOARD: 'straitsx_enable_fazz_va_for_dashboard',
  STRAITSX_ENABLE_FAZZ_VA_FOR_DIRECT_MINT: 'straitsx_enable_fazz_va_for_direct_mint',
  STRAITSX_TRAVEL_RULE_DEPOSIT_DECLARATION: 'straitsx_travel_rule_deposit_declaration',
  STRAITSX_TRAVEL_RULE_ADDR_WHITELISTING: 'straitsx_travel_rule_addr_whitelisting',
  STRAITSX_XSGD_ACCOUNT_STATEMENT_UI: 'straitsx_xsgd_account_statement_ui',
  STRAITSX_DASHBOARD_APPROVAL_FLOW_UI: 'straitsx_dashboard_approval_flow_ui',
  XSGD_USE_FIAT_CURRENCY_NAME: 'xsgd_use_fiat_currency_name',
  STRAITSX_DASHBOARD_BANNER_MANAGEMENT_SYSTEM: 'straitsx_dashboard_banner_management_system',
  XSGD_ERC20_DEPOSIT: 'xsgd_erc20_deposit',
  XSGD_ERC20_WITHDRAWAL: 'xsgd_erc20_withdrawal',
  XSGD_ZRC2_DEPOSIT: 'xsgd_zrc2_deposit',
  XSGD_ZRC2_WITHDRAWAL: 'xsgd_zrc2_withdrawal',
  XSGD_HTS_DEPOSIT: 'xsgd_hts_deposit',
  XSGD_HTS_WITHDRAWAL: 'xsgd_hts_withdrawal',
  XSGD_MATIC_DEPOSIT: 'xsgd_matic_deposit',
  XSGD_MATIC_WITHDRAWAL: 'xsgd_matic_withdrawal',
  XSGD_AVAX_DEPOSIT: 'xsgd_avax_deposit',
  XSGD_AVAX_WITHDRAWAL: 'xsgd_avax_withdrawal',
  XSGD_ARB_DEPOSIT: 'xsgd_arb_deposit',
  XSGD_ARB_WITHDRAWAL: 'xsgd_arb_withdrawal',
  XSGD_XRP_DEPOSIT: 'xsgd_xrp_deposit',
  XSGD_XRP_WITHDRAWAL: 'xsgd_xrp_withdrawal',
  USDT_TRON_DEPOSIT: 'usdt_tron_deposit',
  USDT_TRON_WITHDRAWAL: 'usdt_tron_withdrawal',
  XUSD_BEP20_DEPOSIT_APP: 'xusd_bep20_deposit_app',
  XUSD_BEP20_WITHDRAWAL_APP: 'xusd_bep20_withdrawal_app',
  XUSD_BEP20_DEPOSIT_BIZ: 'xusd_bep20_deposit_biz',
  XUSD_BEP20_WITHDRAWAL_BIZ: 'xusd_bep20_withdrawal_biz',

  // Earn Store
  STRAITSX_APP_DASHBOARD_USE_EARN: 'straitsx_app_dashboard_use_earn',

  // MISC
  MANUAL_ADD_ADDRESS: 'straitsx_manual_add_address_ui',
  ASB_SANDBOX_UI: 'straitsx_asb_sandbox_ui',
  ASB_FE_TO_PASS_TOTAL_AMOUNT_FOR_STABLECOIN_WITHDRAWAL:
    'straitsx_asb_fe_to_pass_total_amount_for_stablecoin_withdrawal',
  WHITELISTING_IMPROVEMENT: 'whitelisting_improvement',
  SG_RECIPIENT_BANK_ACCOUNT_CHANGED_REMINDER:
    'straitsx_sg_recipient_bank_account_changed_reminder_ui',
  RENEW_DEPOSIT_ADDRESS: 'straitsx_renew_deposit_address',
  BITGO_DEPOSIT_ADDRESS_ROTATION_STAGING: 'straitsx_enable_new_bitgo_address_staging',
  BITGO_DEPOSIT_ADDRESS_ROTATION_PRODUCTION: 'straitsx_enable_new_bitgo_address_prod',
  DPT2_TNC: 'straitsx_dpt2_tnc',
  STRAITSX_SANDBOX_DISABLE_MANAGE_ACCOUNTS_PAGE: 'straitsx_sandbox_disable_manage_accounts_page',
  SHIELD: 'straitsx_enable_shield',
  METAMASK_ADD_BLOCKCHAIN_ADDRESS: 'straitsx_metamask_add_blockchain_address',
  TRANSFER_IN_UI_REVAMP: 'straitsx_transfer_in_ui_revamp',
  STRAITSX_TYPEFORM_SURVEY: 'straitsx_typeform_survey',
} as const
